module.exports = __webpack_public_path__ + "static/media/residence-card-front-sample.fc615103.svg";